import { h } from 'preact';
import * as BaseComp from 'components/bolt/videos/videos.js';
import VideoAgeGate from 'components/bolt/videos/videoAgeGate';
import VideoPlayer from 'components/bolt/videos/player';
import VideosPlaylist from 'components/bolt/videos/playlist/playlist';
import { joinClasses, accessNested } from 'utils/utils';
import s from 'components/bolt/videos/videos.sss';
import 'store/bolt/cookies';
import Store from 'store/store';

export default class Videos extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state.throughAgeGate = false;
		this.state.ageGateFadeout = false;

		this.ageGateEnabled = this.props.store?.appData.pages.boltVideos?.data.ageGate;
		
		this.ageGateDenied = this.ageGateDenied.bind(this);
		this.throughAgeGate = this.throughAgeGate.bind(this);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		window.clearTimeout(this.acceptedTimeout);
		window.clearTimeout(this.deniedTimeout);
	}

	throughAgeGate(direct) {
		this.setState({ ageGateFadeout: true });
		this.acceptedTimeout = window.setTimeout(() => {
			this.setState({ throughAgeGate: true });
		}, direct ? 0 : 600);
	}

	ageGateDenied() {
		this.deniedTimeout = window.setTimeout(() => {
			Store.emit('CLOSE_VIDEO_OVERLAY', true);
		}, (this.ageGateEnabled.durationBeforeClosingOverlay || 3) * 1000);
	}
	
	render(props, state) {
		const { appData } = props.store;
		const { throughAgeGate, ageGateFadeout } = state;
		const activeVideo = accessNested(props, 'store.videos.activeVideo') || this.getLandingVideo();
		let { pushDown, height: cookieHeight, cookieBannerOpen } = accessNested(props, 'store.cookies', {});
		const externalBannerOpen = accessNested(props, 'store.externalCookieBanner.bannerOpen');
		const sonyHeader = accessNested(props, 'store.appData.options.sonyFeatures.sonyHeader', false);
		const cookieMode = externalBannerOpen || (pushDown && cookieBannerOpen);
		let height = '';
		let transform = '';
		let paddingTop = (sonyHeader ? 34 : 0) + 'px';

		if (externalBannerOpen) {
			cookieHeight = accessNested(props, 'store.externalCookieBanner.height');
		}

		if (cookieMode) {
			height = `calc(100% - ${cookieHeight}px)`;
			transform = `translateY(${cookieHeight}px)`;
		}

		let hidePlaylist = state.videos.length < 2;

		return (
			<div class={joinClasses(s.container, 'boltVideos')} style={{ ...props.style, height, transform, paddingTop }}>
				<VideoPlayer
					ref={e => this.$player = e}
					activeVideo={activeVideo}
					onEnded={this.onEndedHandler}
					onStart={this.onStartHandler}
					hiddenPlaylist={hidePlaylist}
					noAutoplay={this.ageGateEnabled}
				/>
				<VideosPlaylist
					videos={state.videos}
					activeVideo={activeVideo}
					changeActiveVideo={this.changeActiveVideo}
					hidden={hidePlaylist}
				/>
				{(this.ageGateEnabled && !throughAgeGate) && (
					<div class={joinClasses(s.ageGate, ageGateFadeout && s.fadeOut)}>
						<VideoAgeGate
							copy={appData?.copy}
							appData={appData}
							minAge={this.ageGateEnabled.consentAge}
							cookieExpiry={this.ageGateEnabled.cookieExpiry}
							throughAgeGate={this.throughAgeGate}
							ageGateDenied={this.ageGateDenied}
						/>
					</div>
				)}
			</div>
		);
	}
}
